export const PanelListItemMixin = {
  theme:
    "display: flex; flex-direction: column; height: 100%; justify-content: flex-start; padding: 25px 35px; color: var(--pmbBlack);",
};
